<div class="container" *ngrxLet="selectedSearchValue$; let selectedSearchValue">
    <h3>Hinweise zu den Suchoptionen</h3>
    <div class="image-container">
        <img src="/assets/images/empty-state-{{selectedSearchValue.value}}.svg" alt=""/>
    </div>
    <div class="toggle-container">
        <app-search-toggle></app-search-toggle>
    </div>
    <div class="information">
        <h3>{{getTextToDisplay(selectedSearchValue.value).title}}</h3>
        <div>
            {{getTextToDisplay(selectedSearchValue.value).description}}
        </div>
        <div class="secondary-text">
            {{getTextToDisplay(selectedSearchValue.value).example}}
        </div>
    </div>
    <div class="link-container" >
        <button
            (click)="openInfoDialog()"
            class="open-tips-icon-button"
            data-no-search
        >
            <img src="/assets/icons/info-blue.svg" alt="" />Tipps zur Suche anzeigen
        </button>
    </div>
</div>
